
import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Spinner } from 'reactstrap';
import { del } from '../../../hook/request';
import { toast } from 'react-toastify';

type DeleteConfirmProps = {
  url: string;
  trigger?: React.ReactNode;
  onError?: (err: unknown) => void;
  title?: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
  triggerClassName?: string;
  onSuccess?: () => void;

  // 👇 nuovi (opzionali) per modalità controllata
  isOpen?: boolean;
  onToggle?: (open: boolean) => void;
};

const DeleteConfirm: React.FC<DeleteConfirmProps> = ({
  url,
  trigger,
  onSuccess,
  onError,
  title = 'Conferma eliminazione',
  message = 'Sei sicuro di voler eliminare?',
  confirmText = 'Elimina',
  cancelText = 'Annulla',
  triggerClassName = 'btn btn-sm btn-outline-danger',
  isOpen,
  onToggle,
}) => {
  const [internalOpen, setInternalOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const controlled = typeof isOpen === 'boolean';
  const open = controlled ? isOpen! : internalOpen;

  const setOpen = (next: boolean) => {
    if (controlled) {
      onToggle?.(next);
    } else {
      setInternalOpen(next);
    }
  };

  const toggle = () => {
    if (loading) return;
    setOpen(!open);
  };

  const handleConfirm = async () => {
    try {
      setLoading(true);
      await del<any>(url);
      toast.success('Eliminato con successo');
      setOpen(false);
      onSuccess?.();
    } catch (err) {
      console.error('[DeleteConfirm] errore durante DELETE', err);
      toast.error('Errore durante l’eliminazione');
      onError?.(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Trigger interno SOLO se non è controllato da fuori */}
      {!controlled && (
        trigger ? (
          <span onClick={() => setOpen(true)} style={{ cursor: 'pointer' }}>
            {trigger}
          </span>
        ) : (
          <button
            type="button"
            className={triggerClassName}
            onClick={() => setOpen(true)}
          >
            <i className="fa-solid fa-trash me-1" />
            Elimina
          </button>
        )
      )}

      <Modal isOpen={open} toggle={toggle} centered>
        <ModalHeader toggle={toggle}>{title}</ModalHeader>
        <ModalBody>{message}</ModalBody>
        <ModalFooter className="d-flex justify-content-between">
          <Button
            color="light"
            style={{ color: 'black' }}
            onClick={toggle}
            disabled={loading}
          >
            {cancelText}
          </Button>
          <Button color="danger" onClick={handleConfirm} disabled={loading}>
            {loading ? <Spinner size="sm" /> : confirmText}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default DeleteConfirm;
